<template>
  <div>
    <v-container>
        <h3 class="headline mb-3">{{ titulo }} Representante</h3>


        <v-card>
          <v-card-title>
            Dados do Representante
          </v-card-title>
          <v-divider></v-divider>

          <!-- <z-loading :loading="$store.state.loading" height="100px" color="primary"></z-loading> -->

          <v-container grid-list-md  v-if="!$store.state.loading">
            <!-- <v-layout row wrap>
              <h3 class="subheader">Representante</h3>
            </v-layout> -->
            <v-layout row>
              <v-flex sm6 class="py-0">
                <v-text-field label="Razão Social" v-model="representante.razao" autofocus></v-text-field>
              </v-flex>
              <v-flex sm6 class="py-0">
                <v-text-field label="Nome Fantasia" v-model="representante.fantasia"></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex sm2 class="py-0">
                <v-select :items="$globals.TIPO_PESSOA" label="Pessoa" v-model="representante.tipo_pessoa"></v-select>
              </v-flex>
              <v-flex sm2 class="py-0">
                <z-cpf-cnpj label="CPF/CNPJ" v-model="representante.cpfcnpj"></z-cpf-cnpj>
              </v-flex>
              <v-flex sm2 class="py-0">
                <v-text-field label="RG/Inscrição" v-model="representante.rg_inscricao"></v-text-field>
              </v-flex>
              <v-flex sm6 class="py-0">
                <v-text-field label="Contato" v-model="representante.contato"></v-text-field>
              </v-flex>
            </v-layout>

            <!-- <v-layout row wrap>
              <h3 class="subheader">Endereçamento</h3>
            </v-layout> -->

            <v-layout row wrap>
              <v-flex sm2>
                <z-cep v-model="representante.cep" buscarcep @resultado="preencherEndereco"></z-cep>
              </v-flex>
              <v-flex sm8>
                  <v-text-field label="Endereço" v-model="representante.endereco" @input="value => representante.endereco = value.toUpperCase()"></v-text-field>
              </v-flex>
              <v-flex sm2>
                <v-text-field ref="numero" label="Número" v-model="representante.numero"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex sm5>
                <v-text-field label="Bairro" v-model="representante.bairro" @input="value => representante.bairro = value.toUpperCase()"></v-text-field>
              </v-flex>
              <v-flex sm5>
                <v-text-field label="Cidade" v-model="representante.cidade"  @input="value => representante.cidade = value.toUpperCase()"></v-text-field>
              </v-flex>
              <v-flex sm2>
                <v-select :items="$globals.ESTADOS" label="Estado" v-model="representante.estado"></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex sm12>
                <v-text-field label="Complemento" v-model="representante.complemento" @input="value => representante.complemento = value.toUpperCase()"></v-text-field>
              </v-flex>
            </v-layout>

            <!-- <v-layout row wrap>
              <h3 class="subheader">Contato</h3>
            </v-layout> -->
            <v-layout row wrap>
              <v-flex sm3>
                  <v-text-field label="Telefone" v-model="representante.telefone" mask="(##) ####-####" return-masked-value></v-text-field>
              </v-flex>
              <v-flex sm3>
                  <v-text-field label="Celular" v-model="representante.celular" mask="(##) #####-####" return-masked-value></v-text-field>
              </v-flex>
              <v-flex sm6>
                  <v-text-field label="Email" :rules="regras.email" v-model="representante.email" @input="value => representante.email = value.toLowerCase()" required></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex sm12>
                  <v-textarea label="Observações" placeholder="Observações sobre o  representante" v-model="representante.observacoes"></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>


          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text  @click="$router.push('/cadastros/representantes')" :disabled="salvando">Cancelar</v-btn>
            <v-btn color="primary" @click="confirmar" :loading="salvando">Salvar</v-btn>
          </v-card-actions>
        </v-card>


    </v-container>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
export default {
    name: 'representantes-form',
    data() {
        return {
          titulo: this.$route.meta.editando ? 'Editar' : 'Adicionar',
          representante: {
            tipo_pessoa: 'J',
            estado: 'PE',
            // limite_compra: 0
          },
          salvando: false,
          regras: {},
          tab: ''
        };
    },

    beforeRouteLeave(to, from, next) {
        this.UNSET_REPRESENTANTE();
        next();
    },

    async mounted() {
        if (this.$route.name == "RepresentantesEditar") {
            if (!this.$store.state.representantes.representante) {
                if (this.$route.params.id) {
                    await this.abrir(this.$route.params.id);
                }
            }
            this.representante = this.clone(this.$store.state.representantes.representante);
        }
    },

    methods: {
        ...mapMutations(["setTitulo"]),
        ...mapMutations("representantes", ["UNSET_REPRESENTANTE"]),
        ...mapActions("representantes", ["abrir", "atualizar", "salvar"]),

        async confirmar() {
            try {
                this.salvando = true;

                if (this.$route.params.id) {
                    await this.atualizar(this.representante);
                } else {
                    await this.salvar(this.representante);
                }
            } finally {
                this.salvando = false;
                this.$router.push({ path: "/cadastros/representantes" });
                this.$eventbus.notificar("Representante salvo com sucesso");
            }
        },

        preencherEndereco(endereco) {
            if (endereco.erro) {
                this.representante.endereco = "";
                this.representante.bairro = "";
                this.representante.cidade = "";
                this.representante.estado = "";
                // this.representante.ibge  = '';
            } else {
                this.representante.endereco = endereco.logradouro.toUpperCase();
                this.representante.bairro = endereco.bairro.toUpperCase();
                this.representante.cidade = endereco.localidade.toUpperCase();
                this.representante.estado = endereco.uf.toUpperCase();
                // this.representante.ibge  = endereco.ibge;
                this.$refs.numero.focus();
            }
        }
    },
    watch: {
        'representante.cpfcnpj'(val, oldval){
            this.representante.tipo_pessoa = val.length > 14 ? 'J' : 'F';
        }
    }
};
</script>

<style scoped>
/* .container.grid-list-md .layout .flex{
    padding-top: 0px;
    padding-right: 4px;
    padding-bottom: 0px;
    padding-left: 4px;
} */
</style>
